(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rs-mobile-menu"]) return;
  try {
    
if (!customElements.get('rs-mobile-menu')) {
  customElements.define('rs-mobile-menu', class extends HTMLElement {
    static editingOpen = false;
    static editingPanel = null;
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.abort = new AbortController();
      const options = {signal: this.abort.signal};
      this.reset = group => {
        this.querySelector('[data-rs-root]').hidden = Boolean(group);
        this.querySelectorAll('[data-rs-panel]').forEach(panel => panel.hidden = panel.dataset.rsPanel !== group);
        this.constructor.editingPanel = group;
      };
      this.open = (group, keyboard = false) => {
        this.reset(group);
        if (!this.dialog.open) {
          this.dialog.showModal();
          if (!keyboard) this.querySelector('.rs-menu-head').focus({preventScroll: true});
        }
        document.documentElement.classList.add('rs-menu-open');
        this.constructor.editingOpen = true;
      };
      document.addEventListener('click', event => {
        const trigger = event.target.closest('[data-rs-menu-trigger]');
        if (!trigger) return;
        this.trigger = trigger;
        this.open(null, event.detail === 0);
        trigger.setAttribute('aria-expanded', 'true');
      }, options);
      this.addEventListener('click', event => {
        if (event.target.closest('[data-rs-close]')) this.dialog.close();
        const entry = event.target.closest('[data-rs-open]');
        if (entry) {
          this.reset(entry.dataset.rsOpen);
          this.querySelector('[data-rs-panel]:not([hidden]) [data-rs-back]').focus();
        }
        if (event.target.closest('[data-rs-back]')) {
          const group = event.target.closest('[data-rs-panel]').dataset.rsPanel;
          this.reset(null);
          this.querySelector('[data-rs-open="' + group + '"]')?.focus();
        }
        if (event.target === this.dialog) {
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }
      }, options);
      this.dialog.addEventListener('close', () => {
        this.constructor.editingOpen = false;
        this.constructor.editingPanel = null;
        document.documentElement.classList.remove('rs-menu-open');
        if (this.trigger) {
          this.trigger.setAttribute('aria-expanded', 'false');
          this.trigger.focus();
        }
      }, options);
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        this.open(event.target.closest('[data-rs-panel]')?.dataset.rsPanel || null);
      }, options);
      document.addEventListener('shopify:section:select', event => {
        if (event.target.contains(this)) this.open(null);
      }, options);
      if (this.constructor.editingOpen) this.open(this.constructor.editingPanel);
    }
    disconnectedCallback() {
      this.abort?.abort();
      document.documentElement.classList.remove('rs-menu-open');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-product-details"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rs-product-details')) {
  customElements.define('rs-product-details', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.rsReady) return;
      const source = this.querySelector('[data-rs-description]');
      const track = this.querySelector('[data-rs-track]');
      if (!source || !track) return;
      const removeEmptyWrappers = parent => {
        let empty = parent;
        while (empty && empty !== source && source.contains(empty)) {
          if (!empty.matches('p,div,span,a,picture,figure') || empty.textContent.trim() || empty.querySelector('img,video,iframe,audio,svg,table,input,button,hr,object,embed')) break;
          const next = empty.parentElement;
          empty.remove();
          empty = next;
        }
      };
      const images = Array.from(source.querySelectorAll('img')).filter(image => {
        const picture = image.closest('picture');
        const hasSource = ['src', 'srcset'].some(name => image.getAttribute(name)?.trim()) ||
          (picture && Array.from(picture.querySelectorAll('source')).some(item => item.getAttribute('srcset')?.trim()));
        if (!hasSource) {
          const parent = image.parentElement;
          image.remove();
          removeEmptyWrappers(parent);
        }
        return Boolean(hasSource);
      });
      images.forEach(image => {
        const media = image.closest('picture') || image;
        const parent = media.parentElement;
        const link = media.closest('a');
        const slide = document.createElement('figure');
        if (link && source.contains(link)) {
          const imageLink = link.cloneNode(false);
          imageLink.removeAttribute('id');
          imageLink.append(media);
          slide.append(imageLink);
        } else {
          slide.append(media);
        }
        image.loading = 'lazy';
        image.decoding = 'async';
        track.append(slide);
        removeEmptyWrappers(parent);
      });
      this.querySelector('[data-rs-gallery]').hidden = images.length === 0;
      this.querySelector('[data-rs-swipe]').hidden = images.length < 2;
      this.querySelector('[data-rs-intro]').hidden = !source.textContent.trim() && !source.querySelector('img,video,iframe,audio,svg,table,object,embed');
      const note = this.querySelector('[data-rs-editor-note]');
      if (note) note.hidden = images.length > 0;
      this.dataset.rsReady = 'true';
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
